import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import {GoogleAPI} from '../../utils/util-networkCalls.js';
import { useOvermind } from '../../overmind'

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  }
}));

function ContainerDropDown() {
  const classes = useStyles();
  const { state, actions } = useOvermind();

  const handleChange = (event, value) => {
    actions.setContainerIndex(value.props.value);
  };

  useEffect(() => {
    if(typeof state.authState.googleAccessToken !== 'undefined' && typeof state.containerList === 'undefined'){
      GoogleAPI(state.accountList[state.accountIndex].path+'/containers', state.authState.googleAccessToken)
      .then(response =>{
        actions.getContainerList(response.container);
      });
    }
  });

  if(typeof state.containerList !== 'undefined'){
    return(
      <FormControl variant="filled" className={classes.formControl}>
        <InputLabel id="demo-simple-select-filled-label">Container</InputLabel>
        <Select
          labelId="demo-simple-select-filled-label"
          id="demo-simple-select-filled"
          onChange={handleChange}
        >
          {state.containerList.map(container => <MenuItem key={container.containerId} value={container.containerId}>{container.name + " ("+container.publicId+")"}</MenuItem>)}
        </Select>
      </FormControl>
    );
  }else{
    return(<CircularProgress />);
  }

}

// Need to handle Error for login errors

export default function Container() {
  const { state } = useOvermind();

  return (
    <Grid container direction="column" justify="center" alignItems="center" spacing={2}>
      <Grid item xs={12} md={12} lg={12}>
      <Typography align="center">Last Step I promise!</Typography>
      <Typography align="center">You are currently logged in as <b>{state.authState.email}</b>.</Typography>
      <Typography align="center">You've selected the Account <b>{state.accountList[state.accountIndex].name}</b></Typography>
      <Typography align="center">Which Container would like to use?</Typography>
      </Grid>
      <Grid item xs={12} md={12} lg={12}>
        <ContainerDropDown/>
      </Grid>
    </Grid>

  );
}
